import './administrationNotificationView.scss';
import { ReactComponent as EditIcon } from "../../../../icons/edit.svg";
import { iconStyle } from "../../../../components/shared/stylization";
import { Fragment, useEffect, useState, useContext } from 'react';
import Spinner from '../../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../../components/spinner/types/spinnerProps';
import { NotificationTemplate, NotificationTemplatesResponse } from '../../../../services/administrationService/types/administrationServiceTypes';
import { getNotificationTemplates } from '../../../../services/administrationService/administrationService';
import { apiContext } from '../../../../contexts/apiContext';
import { notifyError } from '../../../../components/snackbar/snackbar';
import EditNotificationConfiguration from './editConfiguration/editNotificationConfigurationModal';

const AdministrationNotificationView = (props: any) => {
    const api = useContext(apiContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [editRow, setEditRow] = useState<NotificationTemplate|null>(null);
    const [templateData, setTemplateData] = useState<NotificationTemplatesResponse>({ features: [], categoryDic: {} });
    const [reload, setReload] = useState<boolean>(false);

    const PropsSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24
    }

    useEffect(() => {
        setLoading(true);
        getNotificationTemplates(api.apiUrl + api.apiVersion).then((res: NotificationTemplatesResponse) => {
            const resData = prepareNewline(res);
            setTemplateData(resData);
            setLoading(false);
        }).catch(err => {
            console.error(err);
            notifyError({ message: "Nie udało się pobrać konfiguracji powiadomień" });
            setLoading(false);
        });
        return () => { }
    }, [api.apiUrl, api.apiVersion, reload]);

    const prepareNewline = (res: NotificationTemplatesResponse) => {
        res.features.map(r => {
            r.temaT_SZABLON = r.temaT_SZABLON?.replaceAll('//n', '/n');
            r.tresC_SZABLON = r.tresC_SZABLON?.replaceAll('//n', '/n');
            return r;
        });
        return res;
    }

    const handleOnClick = (row: NotificationTemplate) => {
        setEditRow(row);
    }

    const decodeValue = (value?: string) => {
        const categoryDic = templateData?.categoryDic;
        const item = value ? categoryDic[value] : undefined;
        return item !== undefined ? item : value;
    }

    const onEditClose = (changed: boolean) => {
        setEditRow(null);
        if (changed) {
            setReload(!reload);
        }
    }

    return (<>
        {loading ? <Spinner spinnerClass={ClassNameSpinner.Big} isMist={true}/> :
            templateData.features.length === 0 ?
                <span className='body-txt-large'>Brak szablonów powiadomień</span> :
                <>
                    <div className="administrationNotificationView">
                        {templateData.features?.map((row: NotificationTemplate) => {
                            return <Fragment key={row.id}>
                                <span className='body-txt-XL'>{decodeValue(row.kategoriA_POWIADOMIENIA_DOM)}</span>
                                <span className='body-txt-large new-lines'>{row.tresC_SZABLON}</span>
                                <span><EditIcon {...PropsSVG} onClick={() => handleOnClick(row)} /></span>
                            </Fragment>
                        })}
                    </div>
                    {editRow !== null && <EditNotificationConfiguration row={editRow} onClose={onEditClose} />}
                </>
        }
    </>)
}

export default AdministrationNotificationView;